var React = require('react');

function RightArrowThin (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_56","data-name":"Group 56","transform":"translate(-27.086 -606.086)"},[React.createElement("line",{"id":"Line_7","data-name":"Line 7","x2":"6.946","y2":"6.946","transform":"translate(28.5 607.5)","fill":"none","stroke":"currentColor","strokeLinecap":"square","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_8","data-name":"Line 8","y1":"6.946","x2":"6.946","transform":"translate(28.5 614.446)","fill":"none","stroke":"currentColor","strokeLinecap":"square","strokeWidth":"2","key":1})]));
}

RightArrowThin.defaultProps = {"viewBox":"0 0 9.775 16.721"};

module.exports = RightArrowThin;

RightArrowThin.default = RightArrowThin;
